import { ComponentType } from "react";
import { SET_DIALOG_HANDLE, SET_DIALOG_HANDLE_IS_OPEN, SET_CAN_CLOSE_DIALOG, SET_DIALOG_TITLE, SET_DIALOG_CHANGED, SET_MULTI_DIALOG_CHANGED } from "../const";


export interface IDialogHandleState<T extends IDialogChildComponent> {
    isOpen: boolean;
    canClose?: boolean;
    Component: ComponentType<T> | null;
    ComponentProps: any | null; // TODO: Fix this any type
    dialogTitle: string | JSX.Element | undefined;
    styles: { className: string } | undefined;
    isFormDialog?: boolean
    onClose?: () => void;
    hasChanged: boolean;
    onCloseIcon?: () => void;
    multiDialogHasChanged?: boolean;
}

const INIT_STATE: IDialogHandleState<any> = {
    isOpen: false,
    Component: null,
    ComponentProps: null,
    dialogTitle: undefined,
    styles: undefined,
    canClose: true,
    isFormDialog: true,
    hasChanged: false,
    onCloseIcon: undefined,
    multiDialogHasChanged:false
}
export interface IDialogChildComponent {
    onClose: () => void;
    onDialogClose?: () => void;
    onCloseIcon?: () => void;
}

/** */
export function dialogReducer(state = INIT_STATE, action: { type: string, payload: any }) {
    const { type, payload } = action;
    switch (type) {
        case SET_DIALOG_HANDLE:
            return {
                ...state,
                styles: {},
                isOpen: true,
                ...payload,
                hasChanged: false
            }
        case SET_DIALOG_HANDLE_IS_OPEN:
            return {
                ...state,
                isOpen: payload,
            }
        case SET_CAN_CLOSE_DIALOG:
            return {
                ...state,
                canClose: payload,
            }
        case SET_DIALOG_TITLE:
            return {
                ...state,
                dialogTitle: payload
            }
        case SET_DIALOG_CHANGED:
            return {
                ...state,
                hasChanged: action.payload
            }
        case SET_MULTI_DIALOG_CHANGED:
            return {
                ...state,
                multiDialogHasChanged: action.payload
            }
        default:
            return state;
    }
}
